/**
 * API Keys configuration file
 * Centralized location for all API keys used in the application
 */

export default {
  googleMaps: 'AIzaSyAyOhIoB0UMUQNbNjo5UKXawm-3O-d0Zb0',
  googleFonts: 'AIzaSyDF9bb4YPqwwSen998gzG-W9rBEB9gKT1U'
}
